import { getValidData } from "../../../Shared/Methods";
import { Tablenodatafound } from "../TableNoDataFount";

function Alertreporttable({ Data, OBJHead }: { Data: any; OBJHead: string[] }) {
  const { items } = Data;

  return (
    <>
      <tr>
        {OBJHead?.map((ele: any) => (
          <th>{ele}</th>
        ))}
      </tr>
      {items?.length > 0 ? (
        items?.map((ele: any, ind: number) => {
          return (
            <>
              <tr>
                <td
                  rowSpan={ele?.data?.length + 1}
                  style={{ minWidth: "103px" }}
                >
                  {getValidData(ele?.date)}
                </td>
              </tr>
              {ele?.data?.map((val: any) => {
                return (
                  <>
                    <tr>
                      <td style={{ width: "100px" }}>{val?.sl_no}</td>
                      <td>{getValidData(val?.time)}</td>

                      <td>{getValidData(val?.parameter)}</td>

                      <td>{getValidData(val?.msg)}</td>

                      <td>{getValidData(val?.value)}</td>
                      <td>{getValidData(val?.limit_name)}</td>
                    </tr>
                  </>
                );
              })}
            </>
          );
        })
      ) : (
        <Tablenodatafound />
      )}
    </>
  );
}

export default Alertreporttable;
